import { type FlagColumn, createFlagColumn } from "@mnk/shared/models/flagColumn";
import * as XLSX from "xlsx";

export interface FlagColumnMap {
  [key: string]: {
    flagColumn: FlagColumn;
    sheets: {
      [key: string]: {
        baseColumn: number | null;
        modifiedColumn: number | null;
      };
    };
  };
}

const getFlagColumn = (currentColumn: number, worksheet: XLSX.WorkSheet) => {
  let columnType = "base";
  const isModified = worksheet[XLSX.utils.encode_cell({ r: 2, c: currentColumn })]?.v;
  if (isModified === "変更後") {
    columnType = "modified";
  }

  const actionName = [
    worksheet[XLSX.utils.encode_cell({ r: 3, c: currentColumn })]?.v,
    worksheet[XLSX.utils.encode_cell({ r: 4, c: currentColumn })]?.v,
  ].join("");
  const unit = worksheet[XLSX.utils.encode_cell({ r: 5, c: currentColumn })]?.v;

  if (["L", "W", "計算式"].includes(unit)) {
    columnType = "ignore";
  }

  return {
    actionName,
    columnType,
    column: currentColumn,
    unit,
  };
};

export const parseHeaderRows = (quantityId: string, data: string | ArrayBuffer) => {
  const flagColumnMap: FlagColumnMap = {};

  // エクセルデータが提供されている場合、B列の値を解析
  const workbook = XLSX.read(data, { type: "binary" });

  // 最初のシートを取得
  for (const sheetName of workbook.SheetNames) {
    const worksheet = workbook.Sheets[sheetName];
    const endCol = detectEndCol(worksheet);

    const startCol = "T";
    let sortOrder = 0;

    for (let col = XLSX.utils.decode_col(startCol); col <= XLSX.utils.decode_col(endCol); col++) {
      const flagColumn = getFlagColumn(col, worksheet);

      if (flagColumn.columnType === "ignore") {
        continue;
      }

      if (!flagColumnMap[flagColumn.actionName]) {
        flagColumnMap[flagColumn.actionName] = {
          sheets: {},
          flagColumn: createFlagColumn({
            name: flagColumn.actionName,
            quantityId,
            sortOrder,
            unit: flagColumn.unit,
          }),
        };
        sortOrder++;
      }

      if (!flagColumnMap[flagColumn.actionName].sheets[sheetName]) {
        flagColumnMap[flagColumn.actionName].sheets[sheetName] = {
          baseColumn: null,
          modifiedColumn: null,
        };
      }

      if (flagColumn.columnType === "modified") {
        flagColumnMap[flagColumn.actionName].sheets[sheetName].modifiedColumn = flagColumn.column;
      } else {
        flagColumnMap[flagColumn.actionName].sheets[sheetName].baseColumn = flagColumn.column;
      }
    }
  }

  return { flagColumnMap };
};

export const detectEndCol = (worksheet: XLSX.WorkSheet) => {
  const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1");
  const row = 4; // 5行目

  // A列から順に走査して、最後の列を見つける
  for (let col = range.e.c; col >= 0; col--) {
    const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
    const cell = worksheet[cellRef];
    if (cell?.v) {
      return XLSX.utils.encode_col(col);
    }
  }

  return "A"; // デフォルト値
};
